/* eslint-disable max-len */
const React = require('react');
const { shape } = require('prop-types');

const { Pagination } = require('@andes/pagination');

const { buildUrl } = require('@pages/V2/utils/clientUtils');

const PaginationComponent = ({ paging = {}, actualLocation }) => {
  const { limit, offset, total } = paging;
  let pageQuantity = Math.min(Math.ceil(total / limit), 20);
  const pageSelected = Math.ceil(offset / limit) + 1;

  if (pageQuantity > 20) {
    pageQuantity = 20;
  }

  const url = buildUrl({ actualLocation, filterId: 'page', filterValueId: '$page', isPagination: true });
  const href = url.replace('%24page', '$page');

  return (
    pageQuantity > 1 && <Pagination pageSelected={pageSelected} pageQuantity={pageQuantity} href={href}></Pagination>
  );
};

PaginationComponent.propTypes = {
  paging: shape({}).isRequired,
};

module.exports = PaginationComponent;
